import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { useHistory } from "react-router";
import { useRequest, useRouterParams } from "../../../abstracts";
import { createPlanStore, setManagePlanToastInfo } from "../../../contexts";
import { deleteFunding, getFunding, listFunding } from "../../../services";

const DeleteSponsorBankAccountCard = ({
  setDeleteCard,
  deleteCard,
  openSlider,
  setOpenSlider,
  Id,
  outerValues,
  setOuterValues,
  bankName,
}) => {
  const { state, dispatch } = useContext(createPlanStore);
  const history = useHistory();

  const buttonHandler = () => {
    setDeleteCard(false);
    //setCancelButtonInsideCard(true);
  };

  const goBack = () => {
    // history.push(
    //   getPathWithParam({
    //     path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
    //     pathParam: planId,
    //   })
    // );
    setOpenSlider(!openSlider);
  };

  const onDeleteClick = () => {
    deleteFunding(parseInt(Id)).then((response) => {
      if (response.isSuccessful) {
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: `Data deleted successfully`,
          })
        );
        setOuterValues({
          ...outerValues,
          Data: outerValues?.Data.filter((_) => _.id !== Id),
        });
        goBack();
      }
    });
  };

  return (
    <>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        size="3x"
        className="mt-3"
        style={{ marginLeft: "30px", marginBottom: "-60px", color: "#EB4E3D" }}
      />
      {deleteCard && (
        <div
          style={{
            padding: "20px 20px 20px 100px",
            width: "auto",
            height: "150px",
            background: "linear-gradient(0deg, #F9E6E8, #F9E6E8), #FFFFFF",
            border: "1px solid #D0273D",
            borderRadius: "5px",
            marginTop: "-40px",
          }}
        >
          <p className="deleteHeader">Delete Bank Account</p>
          <p
            style={{ whiteSpace: "nowrap", fontSize: "13px" }}
          >{`You are attempting to delete bank account ${bankName}`}</p>

          <button
            onClick={() => buttonHandler()}
            className="cancelButton cancelText"
          >
            Cancel
          </button>
          <button
            className="deleteButton deleteText"
            onClick={() => onDeleteClick()}
          >
            Delete
          </button>
        </div>
      )}
    </>
  );
};

export default DeleteSponsorBankAccountCard;
